"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Slider = _interopRequireDefault(require("@material-ui/lab/Slider"));

const PromoSlider = props => {
  const {
    theme,
    onBeforeChange,
    onAfterChange,
    onChange
  } = props,
        otherProps = (0, _objectWithoutProperties2.default)(props, ["theme", "onBeforeChange", "onAfterChange", "onChange"]);
  const {
    value
  } = props;
  const valueRef = (0, _react.useRef)(value); // Material UI Slider doesn't offer a beforeChange handler, so we improvise a custom one based on the first change event

  const [isActive, setIsActive] = (0, _react.useState)(false);

  function beforeChange() {
    onBeforeChange();
  }

  function change(event, newValue) {
    if (!isActive) {
      setIsActive(+new Date());
      beforeChange();
    }

    onChange(newValue);
    valueRef.current = newValue;
  }

  function afterChange() {
    setIsActive(false);
    onAfterChange(valueRef.current);
  }

  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('promo-slider', theme && "promo-slider--".concat(theme))
  }, /*#__PURE__*/_react.default.createElement(_Slider.default, (0, _extends2.default)({
    value: valueRef.current // set the value aside so onAfterChange could pass it along
    ,
    onChange: change,
    onChangeCommitted: afterChange // intentionally ommitting onAfterChange here, our own events are enough

  }, otherProps)));
};

PromoSlider.propTypes = {
  theme: _propTypes.default.oneOf(['monochrome']),
  min: _propTypes.default.number,
  max: _propTypes.default.number,
  step: _propTypes.default.number,
  value: _propTypes.default.number,
  defaultValue: _propTypes.default.number,
  onBeforeChange: _propTypes.default.func,
  onAfterChange: _propTypes.default.func,
  onChange: _propTypes.default.func
};
PromoSlider.defaultProps = {
  theme: undefined,
  min: 0,
  max: 100,
  step: 1,
  value: undefined,
  defaultValue: undefined,
  onBeforeChange: () => {},
  onAfterChange: () => {},
  onChange: () => {}
};
var _default = PromoSlider;
exports.default = _default;